// src/utils/featureFlags.js

/**
 * 機能フラグ名 → 環境変数キー のマッピング
 */
const FEATURE_ENV_MAP = {
  DocumentTypeAll: 'REACT_APP_FEATURE_DOCUMENT_TYPE_ALL',
  // 搭載文書検索の商品名ワード検索欄の表示/非表示を制御するフラグ（初期値: true）
  ProductNameSearch: 'REACT_APP_ENABLE_PRODUCT_NAME_SEARCH',
};

/**
 * 機能フラグが有効かどうかを判定する
 *
 * 判定ルール:
 *   - 環境変数が未設定または空文字 → 無効（デフォルト無効）
 *   - 'true'                      → 有効
 *   - 'false'                     → 無効
 *
 * @param {string} featureName - FEATURE_ENV_MAP に定義されたフラグ名
 * @param {boolean} defaultValue - 環境変数未設定時のデフォルト値
 * @returns {boolean}
 */
const isFeatureEnabled = (featureName, defaultValue = false) => {
  const envKey = FEATURE_ENV_MAP[featureName];
  if (!envKey) {
    console.warn(`[featureFlags] Unknown feature flag: ${featureName}`);
    return false;
  }
  const value = process.env[envKey];
  if (value === undefined || value === '') return defaultValue;
  return value === 'true';
};

/**
 * 「すべて」文書種別（DocumentTypeAll）機能フラグが有効かどうかを返す
 *
 * @returns {boolean}
 */
export const isFeatureEnabledDocumentTypeAll = () => isFeatureEnabled('DocumentTypeAll');

/**
 * 搭載文書検索の商品名ワード検索欄が有効かどうかを返す（デフォルト有効）
 *
 * @returns {boolean}
 */
export const isFeatureEnabledProductNameSearch = () =>
  isFeatureEnabled('ProductNameSearch', true);
